import React from 'react';
import { Form, Input, Select, Button, Typography } from 'antd';
import { roles } from '../../mockData';
import './Invite.css';

function InviteClient() {
  const { Title, Text } = Typography;
  const roleOptions = roles.map((r) => ({ label: r.name, value: r.name }));

  return (
    <div className="agency-clients-invite">
      <Title level={3}>Invite New Client</Title>
      <Text type="secondary">Mock-only invite to demonstrate field wiring.</Text>
      <Form layout="vertical" style={{ marginTop: 16 }} onFinish={(vals) => console.log('Mock invite client', vals)}>
        <Form.Item label="Client Name" name="name" rules={[{ required: true, message: 'Enter client name' }]}>
          <Input placeholder="Acme Corp" />
        </Form.Item>
        <Form.Item label="Primary Contact" name="contact" rules={[{ required: true, message: 'Enter contact name' }]}>
          <Input placeholder="Jane Doe" />
        </Form.Item>
        <Form.Item label="Email" name="email" rules={[{ required: true, type: 'email', message: 'Enter a valid email' }]}>
          <Input placeholder="jane@acme.com" />
        </Form.Item>
        <Form.Item label="Role" name="role" initialValue={roleOptions[0]?.value}>
          <Select options={roleOptions} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">Send Invite</Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default InviteClient;
